import { useEffect } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { MooringMateHomeHeader, GeneralFooter } from "../../components";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";

import "./NotFound.css";

export const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <Box>
      <MooringMateHomeHeader />
      <Container>
        <Grid container spacing={2} className="not-found-container">
          <Grid item xs={12} className="not-found-header">
            <h1>404 - Page Not Found</h1>
            <p>Sorry, the page you are looking for does not exist.</p>
            <Button
              className="btn-primary"
              variant="contained"
              color="primary"
              size="large"
              onClick={() => navigate("/")}
            >
              Go to Home
            </Button>
          </Grid>
        </Grid>
      </Container>
      <GeneralFooter />
    </Box>
  );
};
